import configurationsReducer from './admin/configurations';
import articlesReducer from './articles';
import articleCategoriesReducer from './article-category';
import venturesReducer from './ventures';
import batchsReducer from './batchs';
import ventureForMapsReducer from './venture-for-maps';
import contractsReducer from '../../old/store/reducers/old/contracts';
import customerReducer from '../../old/store/reducers/old/customer';
import customersReducer from '../../old/store/reducers/old/customers';
import professionsReducer from '../../old/store/reducers/old/professions';
import banksReducer from '../../old/store/reducers/old/banks';
import ufsReducer from '../../old/store/reducers/old/ufs';
import taxpayersReducer from '../../old/store/reducers/old/taxpayer';
import CitiesReducer from '../../old/store/reducers/old/cities';
import articlesTemplateReducer from './articles-template';
import galleriesReducer from './galleries';
import paginatedArticlesReducer from './paginated-articles';
import systemReducer from './system';
import usersCrmReducer from './user-crm';

export type ConfigurationReducerType = typeof configurationsReducer;
export type SystemReducerType = typeof systemReducer;
export type ArticlesReducerType = typeof articlesReducer;
export type ArticlecategoriesReducerType = typeof articleCategoriesReducer;
export type ArticlesTemplateReducerType = typeof articlesTemplateReducer;
export type PaginatedArticlesReducerType = typeof paginatedArticlesReducer;
export type GalleriesReducerType = typeof galleriesReducer;
export type VenturesReducerType = typeof venturesReducer;
export type VentureForMapsReducerType = typeof ventureForMapsReducer;
export type BatchsReducerType = typeof batchsReducer;
export type ContractsReducerType = typeof contractsReducer;
export type CustomerReducerType = typeof customerReducer;
export type CustomersReducerType = typeof customersReducer;
export type CitiesReducerType = typeof CitiesReducer;
export type BanksReducerType = typeof banksReducer;
export type ProfessionsReducerType = typeof professionsReducer;
export type ufsReducerType = typeof ufsReducer;
export type taxpayersReducerType = typeof taxpayersReducer;
export type usersCrmReducerType = typeof usersCrmReducer;

export interface RootReducer {
  system: SystemReducerType;
  configurations: ConfigurationReducerType;
  articles: ArticlesReducerType;
  categories: ArticlecategoriesReducerType;
  articlesTemplate: ArticlesTemplateReducerType;
  paginatedArticles: PaginatedArticlesReducerType;
  galleries: GalleriesReducerType;
  ventures: VenturesReducerType;
  ventureForMaps: VentureForMapsReducerType;
  batchs: BatchsReducerType;
  contracts: ContractsReducerType;
  customer: CustomerReducerType;
  customers: CustomersReducerType;
  cities: CitiesReducerType;
  banks: BanksReducerType;
  professions: ProfessionsReducerType;
  ufs: ProfessionsReducerType;
  taxpayers: taxpayersReducerType;
  usersCrm: usersCrmReducerType;
}

const rootReducer: RootReducer = {
  configurations: configurationsReducer,
  system: systemReducer,
  articles: articlesReducer,
  categories: articleCategoriesReducer,
  articlesTemplate: articlesTemplateReducer,
  paginatedArticles: paginatedArticlesReducer,
  galleries: galleriesReducer,
  ventures: venturesReducer,
  ventureForMaps: ventureForMapsReducer,
  batchs: batchsReducer,
  contracts: contractsReducer,
  customer: customerReducer,
  customers: customersReducer,
  cities: CitiesReducer,
  banks: banksReducer,
  professions: professionsReducer,
  ufs: ufsReducer,
  taxpayers: taxpayersReducer,
  usersCrm: usersCrmReducer,
};

export default rootReducer;
